import { useMemo } from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { buildCounterpartyValidationSchema } from '../components/validationSchema.ts';
import { TCounterpartySearchFieldValue } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByClient/types.ts';

export interface ICounterpartySearchFormValues {
  searchCode: TCounterpartySearchFieldValue;
}

const useCounterpartySelectorForm = () => {
  const validationSchema = useMemo(() => buildCounterpartyValidationSchema(), []);

  return useForm<ICounterpartySearchFormValues>({
    resolver: yupResolver(validationSchema) as unknown as Resolver<ICounterpartySearchFormValues>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: {
      searchCode: null,
    },
  });
};

export default useCounterpartySelectorForm;
